export function analysisFilterToIsoRange(
  startDateStr?: string,
  endDateStr?: string
): { startDateIso: string; endDateIso: string } {
  return {
    startDateIso: toStartIso(startDateStr),
    endDateIso: toEndIso(endDateStr),
  };
}

function toStartIso(dateStr?: string): string {
  if (!dateStr) {
    const today = new Date();
    const weekAgo = new Date();
    weekAgo.setDate(today.getDate() - 7);
    return new Date(
      Date.UTC(
        weekAgo.getFullYear(),
        weekAgo.getMonth(),
        weekAgo.getDate(),
        0,
        0,
        0
      )
    ).toISOString();
  }

  const parts = dateStr.split('.');
  if (parts.length !== 3) {
    return toStartIso(undefined);
  }
  const [day, month, year] = parts;
  return new Date(
    Date.UTC(
      parseInt(year, 10),
      parseInt(month, 10) - 1,
      parseInt(day, 10),
      0,
      0,
      0
    )
  ).toISOString();
}

function toEndIso(dateStr?: string): string {
  if (!dateStr) {
    const today = new Date();
    today.setHours(23, 59, 59, 999);
    return today.toISOString();
  }

  const parts = dateStr.split('.');
  if (parts.length !== 3) {
    return toEndIso(undefined);
  }
  const [day, month, year] = parts;
  return new Date(
    Date.UTC(
      parseInt(year, 10),
      parseInt(month, 10) - 1,
      parseInt(day, 10),
      23,
      59,
      59,
      999
    )
  ).toISOString();
}
